import { IonButton, IonCol, IonRow } from "@ionic/react";
import "./TechnoListButton.css";

const TechnoListButton: React.FC = ({}) => {
  return (
    <IonRow className="ion-justify-content-center">
      <IonCol size="12" size-sm="12" size-lg="6">
        <IonButton
          color="tertiary"
          expand="full"
          shape="round"
          onClick={() => (window.location.href = "")}
        >
          Retour
        </IonButton>
      </IonCol>
    </IonRow>
  );
};

export default TechnoListButton;
